import React from 'react';
import DataTable from '../../../ShearCompo/DataTable/DataTable';
import Summary from '../../../ShearCompo/Summary/Summary';
import { Icon } from '@material-ui/core';

import { useState } from 'react';
import ModalLayout from '../../../ShearCompo/ModalLayout/ModalLayout';
import { AssignAdminDetails, AssignAdminFrom } from '../../../AllForms/AdminFrom/AssignAdminFrom';
import { Form } from 'react-bootstrap';
import AntModalLayout from '../../../ShearCompo/AntModalLayout/AntModalLayout';

const AssignAdmin = () => {
    const [userDetails, setUDetails] = useState({})

    // Modal Ant
    const [isModalVisible, setIsModalVisible] = useState(false);
    const showModal = () => setIsModalVisible(true);
    const handleCancel = () => setIsModalVisible(false);
    //Modal Ant


    // Bs5Modal 
    const handleClose = () => setEditDetailsF(false);
    const [editDetailsF, setEditDetailsF] = useState(false);
    const [fromEdit, setFromEdit] = useState();
    const tableHeading = ['Assign ID', 'Name', 'User Name', 'Role', 'Assignment Date', 'User Details', 'Action']
    const assignAdminData = [
        {
            id: '#546651',
            name: 'Shahed Ador',
            userName: 'ador123',
            role: 'Admin',
            creationDate: '4:44AM 17 August, 2021',
            userDetails: 'View Details'
        },
        {
            id: '#546652',
            name: 'Amimul Rahi',
            userName: 'rahi8080',
            role: 'Admin',
            creationDate: '4:44AM 17 August, 2021',
            userDetails: 'View Details'
        },
        {
            id: '#546653',
            name: 'Abu Hasan',
            userName: 'abu123',
            role: 'Editor',
            creationDate: '4:44AM 17 August, 2021',
            userDetails: 'View Details'
        },
        {
            id: '#546654',
            name: 'Saifur Sakib',
            userName: 'sakib123',
            role: 'Editor',
            creationDate: '4:44AM 17 August, 2021',
            userDetails: 'View Details'
        },
        {
            id: '#546655',
            name: 'MeHeDi HaSaN',
            userName: 'mhk123',
            role: 'Editor',
            creationDate: '4:44AM 17 August, 2021',
            userDetails: 'View Details'
        },

    ]
    const assignAdminSummary = [
        {
            name: "Total Admin",
            price: "3 Users",
            img: 'https://i.ibb.co/kgRPWkD/Total-users.png'
        },
        {
            name: "This Year",
            price: "3 Users",
            img: 'https://i.ibb.co/bgJpSVj/This-Year.png'
        },
        {
            name: "This Month",
            price: "1 Users",
            img: 'https://i.ibb.co/5sf3jNQ/This-Months.png'
        },
        {
            name: "This Week",
            price: "0 Users",
            img: 'https://i.ibb.co/HgjVJbz/This-Week.png'
        },
    ];
    const handleDetails = (e) => {
        setEditDetailsF(true);
        const getUserById = assignAdminData.find(data => data.id === e);
        setUDetails(getUserById);
        setFromEdit(false);
    }



    return (

        <div className="w-100 overflow-hidden">
            <>
                <div className="row pt-4">
                    <Summary summaryArrData={assignAdminSummary} summaryTitle="Admin Summary" />
                </div>

                <div className="adminBtn d-flex justify-content-between">
                    <div className="d-flex csvPdfParent">
                        <div className="d-flex align-items-center singleBtn MainLightGreen mx-0">
                            <Icon className="MainLightGreen">download</Icon>
                            <span>Download CSV</span>
                        </div>&nbsp;&nbsp;&nbsp;
                        <div className="d-flex align-items-center singleBtn MainLightGreen mx-0">
                            <Icon className="MainLightGreen">download</Icon>
                            <span>Download PDF</span>
                        </div>
                    </div>
                    <div className=" singleBtn MAIN_BG_DARK_GREEN text-white mx-0">
                        <div onClick={showModal} className="d-flex align-items-center">
                            <Icon className="me-3">add</Icon>
                            <span >Assign Admin</span>
                        </div>
                    </div>
                </div>
                {/* Assign Admin  from */}
                <AntModalLayout
                    ModalTitle="Assign Admin"
                    isModalVisible={isModalVisible}
                    handleCancel={handleCancel}
                    AntModalFrom={<AssignAdminFrom />}
                />
            </>
            <DataTable
                tableInputFrom={
                    <Form className="col-lg-5 p-0 tableSearch topInputFrom" id="topInputFrom1">
                        <div className="form-bd shadow-sm rounded">
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <button id="button-addon3" type="submit" className="btn btn-link text-muted d-flex align-items-center">
                                        <Icon className="mt-1">search</Icon>
                                    </button>
                                </div>
                                <input type="search" placeholder="Search assign admin" className=" topSearchInput form-control rounded " />
                            </div>
                        </div>
                    </Form>
                }
                tableHeading={tableHeading} tableBodyData={
                    assignAdminData && assignAdminData.map((tableData, index) =>
                        <tr key={index} className="text-center">
                            <th scope="row">{tableData.id}</th>
                            <td>{tableData.name}</td>
                            <td>{tableData.userName}</td>
                            <td>{tableData.role}</td>
                            <td> {tableData.creationDate} </td>
                            <td className="text-success cursorPointer text-decoration-underline" onClick={() => { handleDetails(tableData.id) }}> {tableData.userDetails} </td>
                            <td className="text-danger cursorPointer d-flex align-items-center justify-content-center">
                                <i className="far fa-trash-alt"></i>&nbsp;&nbsp;
                                <span className="text-decoration-underline">remove mapping</span>
                            </td>
                        </tr>
                    )
                } />
            <ModalLayout
                ModalTitle={`${'Asssign ID-' + userDetails.id}`}
                Show={editDetailsF}
                handleClose={handleClose}
                modalBody={
                    // user Edit From 
                    <AssignAdminDetails
                        userDetails={userDetails}
                        which={fromEdit && fromEdit} />
                }
            />
        </div>
    );
};

export default AssignAdmin;